import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.farmcity.in/";
// export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://192.168.68.104:5000/";
export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (window.location.pathname !== "/login") {
        window.location.assign("/login?reason=session-expired");
      }
    }
    return Promise.reject(error);
  }
);
